const homePageContent = {
    title: 'Home',
    description: `Welcome to **Saved Clay**. Here you will find blog posts, resources, and other notes that I've put together over time.`,
    note: `
    **Isaiah 64:8**
    *"But now, O Lord , you are our Father; we are the clay,
    *and you are our potter; we are all the work of your hand."\m-b
    
    \n**Romans 9:21**
    *"Has the potter no right over the clay, to make out of
    *the same lump one vessel for honorable use and another
    *for dishonorable use?"\m-b`

    // **-**\m-b

    // **Links I find useful:**
    // *Goes without saying, however, that you should take
    // *their info with a grain of salt and do your own research!\m-b

    // Helpful MSS Website:
    // {link:https://earlybible.com/manuscripts}
    // \m-b

    // Bible Timeline:
    // {link:https://biblehub.com/timeline/}
  };

export default homePageContent;